import { axiosBase, errorHandler } from "./axios";


const createService = (data: any) => {
  return axiosBase.post("service/save", data).
  then((response) => response.data).
   catch((error) => errorHandler(error));
};

const getService = (data:any) => {
  return axiosBase.get("service/list",{params:data}).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}


const getServiceParams = (data: any) => {
  return axiosBase.get("service/list", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const getServiceView = (data: any) => {
  return axiosBase.get(`service/view/${data.id}`).
  then((response) => response.data).
   catch((error) => errorHandler(error));
};

const toggleService = (data: any) => {
  return axiosBase.post(`service/save`, data).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const deleteService = (data: any) => {
  return axiosBase.delete(`service/delete/${data}`).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const deleteFiles = (data: any) => {
  return axiosBase.post("common/fileDelete", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
} 

const contactMailService = (data: any) => { 
  return axiosBase.post("common/sendMail", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const userProfileImage = (data: any) => {
  return axiosBase.post(`common/fileUpload`, data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getPrivacyPolicy = (data: any) => {
  return axiosBase.get("common/getPrivacyPolicy", { params: data })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const getTermsOfService = (data: any) => {
  return axiosBase.get("common/getTermsAndConditions", { params: data })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}


export const commonService = {
  createService,
  getService,
  getServiceParams,
  getServiceView,
  deleteService,
  toggleService
  ,deleteFiles,
  userProfileImage,
  contactMailService,
  getTermsOfService,
  getPrivacyPolicy
};